// @flow

import * as React from "react";
import { connect } from "react-redux";
import { Col, Row, Button, Alert } from "react-bootstrap";
import YourSummaryForm from "./form";
import { submit, hasSubmitSucceeded, formValueSelector } from "redux-form";
import { withRouter, RouterHistory } from "react-router-dom";

import {
  postBasketData,
  proceedStep,
  lastBlurredField,
  fetchBasketData
} from "../../../actions/basket";
import currencySymbols from "../../../utils/currencySymbols";
import {
  transferDetailsOutboundFields,
  transferDetailsOutboundSelectors,
  transferDetailsOutboundState,
  SubHeaderOutbound
} from "./yourSummaryOutboundData";
import {
  transferDetailsInboundFields,
  transferDetailsInboundSelectors,
  transferDetailsInboundState,
  SubHeaderInbound
} from "./yourSummaryInboundData";
import "./styles.css";

type Props = {
  history: RouterHistory,
  outboundChildren: number,
  inboundChildren: number,
  initialInboundValues: any,
  initialOutboundValues: any,
  activeKey: string,
  dispatch: Function,
  transfers: Object
};

export class YourSummaryPanel extends React.Component<Props, void> {
  props: Props;

  constructor(props) {
    super(props);

    this.state = {
      submit: false,
      submitting: false

    };
  }

  navigate = () => {
    this.setState({ submit: false });
    if (this.props.user.id) {
      this.props.history.push("/confirm");
    } else {
      this.props.history.push("/login");
    }
  };

  componentWillUpdate(nextProps: Props, nextState) {
    if (!nextProps.continueText.show && nextState.submit) {
      if (
        nextProps.transfers[1] &&
        (!nextProps.submitOutboundSucceeded ||
          !nextProps.submitInboundSucceeded)
      )
        return false;
      if (
        nextProps.transfers[1] &&
        nextProps.submitOutboundSucceeded && nextProps.submitInboundSucceeded
      )
        return this.navigate();
      if (!nextProps.transfers[1] && nextProps.submitOutboundSucceeded)
        return this.navigate();
    }

    // This was commented out when P left. I have put it back for now. JT.
    if (this.state.submit) this.setState({ submit: false });
  }

  submitData = () => {
    this.props.lastBlurredField("");
    this.props.proceedStep(this.props.basketId, "confirm").then(() => {
      this.setState({ submit: true }, this.handleSubmit);
    });
  };

  handleSubmit = () => {
    this.props.submit("transferDetailsOutboundForm");
    this.props.submit("transferDetailsInboundForm");
  };
  // JT. I've added this to submit both forms when the component mounts. Not sure if this
  // is a hack or not, and if there are any weird side effects of doing it.
  componentDidMount() {
    this.props.submit("transferDetailsOutboundForm");
    this.props.submit("transferDetailsInboundForm");
  }
  confirmData = () => {
    this.setState({ submitting: true });
    this.props
      .postBasketData(null, null, null, true, true)
      .then(response => {
        
        if (response.result === "error") {
          throw Error(response.message);
        }
      })
      .then(this.submitData)
      .then(this.submitData)
      .catch(() => console.error("error saving cart please contact Admin"));
  };

  render() {
    const {
      transfers,
      initialInboundValues,
      initialOutboundValues,
      money,
      continueText
    } = this.props;

    const displayPrice = this.props.showCost
      ? (money.totalToPay / 100).toFixed(2)
      : "TBC";

    if (!transfers)
      return (
        <div className="text-center">
          <h1 style={{ color: "red" }}>Server Error</h1>
        </div>
      );
    return (
      <div className="panel-body container your-summary">
         { this.state.submitting && !continueText.show ? (<div className="spinner"> <i className="fa fa-circle-o-notch fa-spin fa-5x fa-fw" /></div>) : null }
        <div>
          {transfers && transfers.length < 2 ? (
            <Row>
              <Col xs={12} className="one">
                <YourSummaryForm
                  activeKey={this.props.activeKey}
                  header="Outbound Journey"
                  transferHeader="Your Details (Outbound)"
                  form="transferDetailsOutboundForm"
                  fieldData={transferDetailsOutboundFields(
                    this.props.outboundChildren,
                    transfers[0],
                    this.props.options,
                    this.props.info
                  )}
                  selectorData={transferDetailsOutboundSelectors(
                    this.props.outboundChildren
                  )}
                  stateData={transferDetailsOutboundState(
                    this.props.outboundChildren
                  )}
                  children={this.props.outboundChildren}
                  subheader={SubHeaderOutbound}
                  style={{ margin: "0  auto " }}
                  panel="yourSummaryPanel"
                  postBasketData={this.props.postBasketData}
                  basketId={this.props.basketId}
                  transfers={transfers[0]}
                  initialValues={initialOutboundValues}
                  proceedStep={this.props.proceedStep}
                />
              </Col>
            </Row>
          ) : (
            <div className="summary-panel-details">
              <Col className="one">
                <YourSummaryForm
                  activeKey={this.props.activeKey}
                  header="Outbound Journey"
                  transferHeader="Your Details (Outbound)"
                  form="transferDetailsOutboundForm"
                  fieldData={transferDetailsOutboundFields(
                    this.props.outboundChildren,
                    transfers[0],
                    this.props.options,
                    this.props.info
                  )}
                  selectorData={transferDetailsOutboundSelectors(
                    transfers[0].children.length
                  )}
                  stateData={transferDetailsOutboundState(
                    transfers[0].children.length
                  )}
                  children={this.props.outboundChildren}
                  subheader={SubHeaderOutbound}
                  panel="yourSummaryPanel"
                  postBasketData={this.props.postBasketData}
                  basketId={this.props.basketId}
                  transfers={transfers[0]}
                  initialValues={initialOutboundValues}
                  proceedStep={this.props.proceedStep}
                />
              </Col>
              <Col  className="two">
                <YourSummaryForm
                  activeKey={this.props.activeKey}
                  header="Return Journey"
                  transferHeader="Your Details (Return)"
                  form="transferDetailsInboundForm"
                  fieldData={transferDetailsInboundFields(
                    this.props.inboundChildren,
                    transfers[1],
                    this.props.options,
                    this.props.info
                  )}
                  selectorData={transferDetailsInboundSelectors(
                    transfers[1].children.length
                  )}
                  stateData={transferDetailsInboundState(
                    transfers[1].children.length
                  )}
                  children={this.props.inboundChildren}
                  subheader={SubHeaderInbound}
                  panel="yourSummaryPanel"
                  postBasketData={this.props.postBasketData}
                  basketId={this.props.basketId}
                  transfers={transfers[1]}
                  initialValues={initialInboundValues}
                  proceedStep={this.props.proceedStep}
                />
              </Col>
            </div>
          )}

          <Row className=" continueMessage">
            <Col>
              {continueText && continueText.show ? (
                <Alert bsStyle="success">
                  <h4>
                    {continueText && continueText.title
                      ? continueText.title
                      : null}
                  </h4>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: continueText.message
                    }}
                  />
                </Alert>
              ) : null}
            </Col>
          </Row>

          <Row className="text-center your-summary-confirm">
            <Col xs={12} sm={6} mdPush={1}>
              <div>
                <h3><strong>Booking Total:</strong> {`${
                  currencySymbols[money.currency[0]]
                }${displayPrice}`}</h3>
              </div>
              
            </Col>
            <Col xs={12} sm={6} mdPull={1} style={{ margin: "10px 0" }}>
              <Button
                bsSize="large"
                bsStyle="success"
                type="submit"
                onClick={this.confirmData}
              >
                <span>CONFIRM MY DETAILS</span>
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const inboundSelector = formValueSelector("transferDetailsInboundForm");
const outboundSelector = formValueSelector("transferDetailsOutboundForm");

export default withRouter(
  connect(
    state => ({
      inboundChildren: inboundSelector(state, "children"),
      outboundChildren: outboundSelector(state, "children"),
      submitOutboundSucceeded: hasSubmitSucceeded(
        "transferDetailsOutboundForm"
      )(state),
      submitInboundSucceeded: hasSubmitSucceeded("transferDetailsInboundForm")(
        state
      ),
      user: state.user
    }),
    { postBasketData, proceedStep, submit, lastBlurredField, fetchBasketData }
  )(YourSummaryPanel)
);



// WEBPACK FOOTER //
// ./src/containers/QuotePage/YourSummaryPanel/index.js